module.exports = __webpack_public_path__ + "images/apply-special.ab36fcca.png";